import SiteHeader from '@/pages/home/components/SiteHeader';
import Hero from '@/pages/home/components/Hero';
import IntroSection from '@/pages/home/components/IntroSection';
import StepsSection from '@/pages/home/components/StepsSection';
import TipsSection from '@/pages/home/components/TipsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import PicksSection from '@/pages/home/components/PicksSection';
import FaqSection from '@/pages/home/components/FaqSection';
import VoicesSection from '@/pages/home/components/VoicesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <IntroSection />
        <StepsSection />
        <TipsSection />
        <TopicsSection />
        <PicksSection />
        <FaqSection />
        <VoicesSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}